<template>
  <div
    class="tw-relative tw-inline-block"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <slot></slot>
    <span
      v-if="isHovered"
      :id="props.id"
      class="tw-absolute tw-z-10 tw-h-fit tw-min-w-max tw-rounded tw-border tw-border-solid tw-border-primary-grey-200 tw-bg-white tw-px-2 tw-shadow"
      :class="classes"
      role="tooltip"
    >
      {{ text }}
    </span>
  </div>
</template>
<script setup lang="ts">
/**
 * @deprecated
 *
 * Please use `VueTippy` instead.
 * https://vue-tippy.netlify.app/
 */

import { ref, computed } from "vue";

import type { Position } from "./types";

export interface TooltipProps {
  id: string;
  text: string;
  position?: Position;
}

const positions = {
  top: "tw--top-3 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-transform",
  bottom:
    "tw--bottom-8 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-transform",
};

const props = withDefaults(defineProps<TooltipProps>(), {
  position: "top",
});

const classes = computed(() => {
  return [positions[props.position]];
});

// TODO: Implement position left, right
// TODO: Implement click to show or hover to show
const isHovered = ref(false);
</script>
